export const VERSION_TABLES = [
    'classes',
    'groups',
    'teachers',
    'subjects',
    'rooms',
    'bell_schedule',
    'days',
    'classes_types',
    'buildings',
    'calendar_schedule',
    'current_streams',
    'curriculum',
    'cyclical_commissions',
    'directions',
    'funding_types',
    'industrial_practice',
    'practice_schedule',
    'workloads',
]

export const DEFAULT_VERSION_TABLE = 'classes'

export const HISTORY_TABS = {
    export: 'export',
    versions: 'versions',
    audit: 'audit',
}

export const ACTION_LABEL = {
    insert: 'Добавлено',
    update: 'Изменено',
    delete: 'Удалено',
}

export const AUDIT_FIELD_LABEL = {
    class_date: 'Дата',
    day_id: 'День',
    bell_id: 'Пара',
    group_id: 'Группа',
    subject_id: 'Предмет',
    teacher_id: 'Преподаватель',
    room_id: 'Аудитория',
    class_type_id: 'Тип',
}

export const VERSION_PREVIEW_LIMIT = 100
